import React, { useEffect, useState } from 'react'
import useList from 'hooks/useList'
import { getProcessingList } from '../utils/network'
import { formatDate } from '../../../utils/time'
import { TASK_STATUS_NAME, TASK_STATUS } from '../constants'
import { PLATFORM_NAME } from 'biz-components/ChannelPkgList/constants'
import { PopOver, OverlayTrigger } from '@tencent/spaui'

export const useProcessingList = props => {
    const { setProcessCount = () => {}, activeTab } = props
    const { state, setState } = useList({
        updateDataAPI: getProcessingList,
        dataFormatter: null,
        filterSelectValue: -1,
    })
    const { updateList } = setState
    const [prevActiveTab, setPrevActiveTab] = useState('0')
    const colRender = (type, name, value, rowData) => {
        if (type === 'head') {
            return value
        }
        if (name === 'createTime' || name === 'updateTime') {
            return formatDate(+value * 1000, 'yyyy-MM-dd hh:mm:ss')
        }
        if (name === 'status') {
            if (value === TASK_STATUS.ERROR) {
                const popover = <PopOver>{rowData.desc}</PopOver>
                return (
                    <div className="channel-package-error-text">
                        <span>{TASK_STATUS_NAME[value] || value}</span>
                        <OverlayTrigger trigger="hover" placement={'right'} overlay={popover} hideDelayTime={0}>
                            <i className="spaui-icon icon-help" style={{ marginLeft: 10, verticalAlign: 'middle' }}>
                                <i></i>
                            </i>
                        </OverlayTrigger>
                    </div>
                )
            } else {
                return <span>{TASK_STATUS_NAME[value] || value}</span>
            }
        }
        if (name === 'platform') {
            return PLATFORM_NAME[value]
        }
        return value
    }
    useEffect(() => {
        // 切换到校验处理
        if (prevActiveTab === '0' && activeTab === '1') {
            updateList()
        }

        if (prevActiveTab !== activeTab) {
            setPrevActiveTab(activeTab)
        }
        let _totalSize = state.totalSize
        if (_totalSize > 0) {
            if (_totalSize > 100) {
                _totalSize = '(99+)'
            } else {
                _totalSize = `(${_totalSize})`
            }
        }
        setProcessCount(_totalSize)
    }, [setProcessCount, prevActiveTab, activeTab, state.totalSize, updateList])

    return { state, setState, colRender }
}

export default useProcessingList
